import { DEFAULT_REQUEST_OPTIONS } from "./common/requestParameter";
import { SOURCE_ID, hostServerAddress, directUserServerAddress } from "./common/MetaSetting";
import { ROUTES_LIST } from "./home/constants";

export interface CaptchaResponse {
    captchaId: string;
    imageBase64: string;
}

export interface CaptchaValidationRequest {
    captchaId: string;
    captchaCode: string;
}

export const getCaptcha = async (): Promise<CaptchaResponse> => {
    const response = await fetch(`${directUserServerAddress}/register/captcha`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`获取验证码失败: ${response.statusText}`);
    }

    const result = await response.json();
    if (result.code !== 200) {
        throw new Error(`获取验证码失败: ${result.message}`);
    }

    return result.data;
};

export const validateCaptcha = async (captchaId: string, captchaCode: string): Promise<boolean> => {
    const response = await fetch(`${directUserServerAddress}/register/captcha/validate`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ captchaId, captchaCode }),
    });

    if (!response.ok) {
        throw new Error(`验证码验证失败: ${response.statusText}`);
    }

    const result = await response.json();
    if (result.code !== 200) {
        throw new Error(`验证码验证失败: ${result.message}`);
    }

    return result.data;
};
export function sendRequestToUCServer(username: string, emailAddressString: string, password: string, confirmPassword: string, realName: string, phone: string, captchaId: string, captchaCode: string) {
   var registerRequest = {
     username: username,
     email: emailAddressString,
     password: password,
     confirmPassword: confirmPassword,
     realName: realName,
     phone: phone,
     captchaId: captchaId,
     captchaCode: captchaCode
   };

  var myInit = Object.assign({}, DEFAULT_REQUEST_OPTIONS, {
    method: "POST",
    body: JSON.stringify(registerRequest),
  });

  return fetch(`${directUserServerAddress}/register`, myInit)
    .then(async (response) => {
      // 解析ApiResponse对象
      const apiResponse = await response.json();
      console.log('注册请求API响应:', apiResponse);

      if (!response.ok) {
        // 根据ApiResponse的code和message抛出更详细的错误信息
        throw new Error(`API错误! 状态码: ${response.status}, 错误码: ${apiResponse.code}, 消息: ${apiResponse.message}`);
      }

      // 返回完整的ApiResponse对象
      return apiResponse;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
}

export function sendConfirmCodeToUCServer(username: string, code: string) {
  var confirmRequest = { username: username, code: code };

  var myInit = Object.assign({}, DEFAULT_REQUEST_OPTIONS, {
    method: "PUT",
    body: JSON.stringify(confirmRequest),
  });

  return fetch(`${directUserServerAddress}/register/confirm`, myInit)
    .then(async (response) => {
      // 解析ApiResponse对象
      const apiResponse = await response.json();
      console.log('确认码验证API响应:', apiResponse);

      if (!response.ok) {
        // 根据ApiResponse的code和message抛出更详细的错误信息
        throw new Error(`API错误! 状态码: ${response.status}, 错误码: ${apiResponse.code}, 消息: ${apiResponse.message}`);
      }

      // 返回完整的ApiResponse对象
      return apiResponse;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
}
